export const validarCNPJ = (cnpjSujo) => {
    if (!cnpjSujo) {
        return cnpjSujo
    }
    const cnpj = cnpjSujo.replace(/[^A-Z0-9]/g, '').toUpperCase();

    if (cnpj.length !== 14 || /^(.)\1{13}$/.test(cnpj)) {
        return false;
    }

    let length = cnpj.length - 2;
    let numeros = cnpj.substring(0, length);
    const digits = cnpj.substring(length);
    let sum = 0;
    let pos = length - 7;
    for (let i = length; i >= 1; i--) {
        sum += (numeros.charCodeAt(length - i) - 48 ) * pos--;
        if (pos < 2) pos = 9;
    }
    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(0))) return false;

    length += 1;
    numeros = cnpj.substring(0, length);
    sum = 0;
    pos = length - 7;
    for (let i = length; i >= 1; i--) {
        sum += (numeros.charCodeAt(length - i) - 48) * pos--;
        if (pos < 2) pos = 9;
    }
    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(1))) return false;

    return true;
};